<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">支付成功</h2>
            <p class="weui-msg__desc" v-if="account_status==1"><br>您下单时没有登录，我们已经将该订单绑定到<br>您的<span class="color-orange">手机号账号</span>，请登录查看订单详情</p>
            <p class="weui-msg__desc" v-if="workingHours<9 || workingHours>=21" v-show="$route.query.pay_status==0" >亲爱的用户，我们客服工作时间是 <span class="color-orange">09:00 - 21:00</span><br>上班后将尽快给您致电确认订单，请保持手机畅通<br></p>
            <p class="weui-msg__desc" v-else v-show="$route.query.pay_status==0">客服将尽快向您致电确认订单，请保持手机畅通</p>

            <p class="weui-msg__desc" v-if="account_status==2"><br>我们已经为您的手机号注册了到家账号<br>请点击下方按钮设置密码</p>
            <p class="weui-msg__desc" v-show="$route.query.pay_status==2">服务已完成，希望您满意我们的服务！</p>
        </div>
        <div class="btn-box" v-if="account_status==2">
          <div class="btn active" @click="$router.push('/new-password')">设置账号密码</div><br>
        </div>
        <div class="btn-box" v-else>
          <div class="btn active" @click="checkOrder()">查看我的订单</div><br>
        </div>
    </div>
    <transition name="fade" >
        <div id="loadingToast" v-show="ifShowQues">
            <div class="weui-mask"></div>
        </div>
    </transition>
    <div id="js_dialog_1" class="weui-half-screen-dialog" :class="{ 'weui-half-screen-dialog_show': ifShowQues}">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__side">
            <span class="icon-x" @click="ifShowQues=false"></span>
          </div>
          <div class="weui-half-screen-dialog__hd__main">
            <strong class="weui-half-screen-dialog__title">您是从哪里认识<span class="color-orange"> 到家 </span>的</strong>
          </div>
        </div>
        <div class="weui-half-screen-dialog__bd" >
          <div class="loading-circle" v-show="Qloading" @click="ifShowQues=false">
            <img src='../../assets/img/global/loading.svg'>
            非常感谢您的回答<br>正在提交..
          </div>
          <div :class="{ visualhidden: Qloading}" class="optionList">

            <div v-for="(item, index) in question" class="options" v-show="item.id!=1615943880" @click="Qanswer(item.id)">{{item.name}}</div>

            <div class="options" @click="QotherShow()" :class="{ active: Qother}"  >其他</div>
            <div class="Qinput" v-show="Qother" >
            <input type="text" placeholder="请输入您认识到家的途径" ref="otherText" v-model="other_source">
            <button @click="Qanswer('1615943880')">提交</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'order-success',
  data () {
    return {
      ifShowQues:false,
      Qloading:false,
      Qsuccess:false,
      Qother:false,
      question:[],
      other_source:""
    }
  },
  methods: {
    checkOrder(){
      history.replaceState(null, null, '/#/order');
      this.goto('/order-detail?id='+this.$route.query.id);
    },
    Qanswer(id){
      this.Qloading = true;
      let that = this;

      let qObject ={};
      qObject.phone = localStorage.phone_question;
      qObject.source = id;

      if(id==1615943880){
        qObject.other_source = this.other_source;
      }

      console.log(qObject);

      this.axios.post(this.apiURL()+'/Globals/member_source', qs.stringify(qObject))
      .then(function (response) {
        console.log(response);
        if(response.data.error_code==0){
          localStorage.removeItem('is_questions');
          localStorage.removeItem('questions');
          localStorage.removeItem('phone_question');
          that.sleep(2000).then(() => {
            that.ifShowQues = false;
          });
          
        }
        else{
          alert("提交失败："+response.data.data)
          that.Qloading=false;
        }
      })
      .catch(function (error) {
        alert("提交失败，请检查网络并重新尝试")
        that.Qloading=false;
        console.log(error);
      });
    },
    QotherShow: function () {
      this.Qother=true;
      this.sleep(20).then(() => {
        this.$refs.otherText.focus();
      });
    },
  },
  created: function () {
    if (localStorage.is_questions==1) {
      this.ifShowQues = true;
    }
    if (localStorage.questions) {
      this.question = JSON.parse(localStorage.questions);
    }
    if (localStorage.account_status) {
      this.account_status = localStorage.account_status;
      if(this.account_status==2){
        localStorage.surveyID = this.$route.query.id;
      }
    }
  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

.optionList{
  text-align:center;
}

.options{
  display:inline-block;
  margin:5px 0;
  padding:8px 0;
  width:80%;
  border-radius:5px;
  background-color:#eee;
  text-align:center;
  font-size:0.84em;
}

.options:hover, .options.active{
    background-color:#ff7444;
    color:#fff;
}

.loading-circle{
  width:50%;
  margin:0 auto;
  position:absolute;
  left:25%;
}

.Qinput{
  display: inline-block;
  margin: 5px 0;
  width: 80%;
  text-align:left;
  input{
    width:68%;
    font-size:14px;
    border:1px solid #ccc;
    border-radius:4px;
    padding: 9px;
    float:left;
  }
  button{
    width:20%;
    padding: 8px;
    float:right;
    background-color:#ff7444;
    border:#ff7444;
    color:#fff;
    border-radius:5px;

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-success.vue